export default "__VITE_ASSET__DjWPVg0B__"